
<template>
  	<div class="boxbgcolor" style="overflow-y: scroll">
		<div class="content-left">
			<AreaTree ref='areaTree' :moduleName='moduleName' v-on:handleTreeClick="handleTreeClick"></AreaTree>
		</div>
		<div class="right content-right">
				<!-- <div id="myChart" style="width: 100%;height:250px;"><p>泊位利用率</p></div> -->
			
			<div class="list-right" style="height:100%;">
					<el-table
					ref='table'
					border
					:data="tableListData"
					height='100%'
					:header-cell-style='tableHeaderStyle'
					:cell-style='styleObj'
				>	
					<el-table-column  show-overflow-tooltip
						label="设备种类"
						prop="typeName"
					>
					</el-table-column> 
					
					<el-table-column  show-overflow-tooltip
						label="设备总数"
						prop="totalNum"
					>
					</el-table-column>
					<el-table-column  show-overflow-tooltip
						label="故障数"
						prop="failureNum"
					>
					</el-table-column>
					<el-table-column  show-overflow-tooltip
						label="故障率(%)"
						prop="failureRate"
					>
					</el-table-column>
				</el-table>

			</div>
		</div>
		
  	</div>
</template>

<script>
	import { mapState, mapMutations,mapGetters } from 'vuex';
	import {spaceAnalyzeList,chargeChartList,statistics,analyse,equipmentList} from '@/api/url';
	import AreaTree from '../../commons/areaTree';
	import Page from '../../commons/page';
	
	// import Refresh from "../../commons/refresh.vue";
	export default{
		data(){
			return{
				treeData:{
					parkingId:'',
				},
				styleObj:{
					'text-align':'center',
				},
				tableHeaderStyle:{
					'text-align':'center',
					'background':'#F9F9FB'
				},
				switchValue:'list',
				showList:true,
				showChart:false,
				search:{
					pageSize:10,
					pageNumber:1,
					beginTime:'',
					endTime:''
				},
				tableListData:[],
				tableListDataTitle:[],
				  dialogFormVisibleRule:false,    
				parklist_btn_rule: false,
				parkset_btn_removeArea:false,
				parkset_btn_addArea:false,
				parkset_btn_editArea:false,
				dialogFormVisibleArea:false,
				selectedPark:false,
				parkList:false,
				dialogFormVisibleRule:false,
				parkingName:"",
				tableListParkDataAll:{},
				tableListDataAll:{},
				dateList:[],
				dataList:[]
            
			}
		},
		methods:{
			...mapMutations(['getPage']),
			//点击树的节点展示相应数据
			handleTreeClick:function(node,data){
					this.switchValue='list';
					this.showList=true;
					this.showChart=false;
					this.search.beginTime='';
					this.search.endTime='';

					if(node.type=='parking'){
					this.treeData.parkingId=node.id;
					this.search.pageNumber=1;
					this.tableList(this.search.pageNumber);
					}else{
					this.treeData.parkingId='';
					this.tableListData=[];
					// this.myChart.series[0].data=[];
					// this.myChart.xAxis[0].data=[];
					// let myChart = this.$echarts.init(document.getElementById('myChart'));
					// myChart.setOption(this.myChart);

					// var pageObj={
					// 		curIndex:1,
					// 		rowsCount:0
					// 	};
					// this.getPage(pageObj);
					//  this.$message({
					// 	message: '请选择车场！',
					// 	type: 'warning'
					// 	});
					}
			},
			tableList:function(curPage){
				var _this=this;
				this.$get(equipmentList(),{
					parkingId:this.treeData.parkingId,
				}).then((data) => {	
					   _this.tableListData=data.data;
					for(var i in data.data){
						data.data[i].failureRate=parseFloat(data.data[i].failureRate).toFixed(2);
					}
  				});
			}
		},
		computed:{
			...mapState({
			curIndex: state => state.page.curIndex,
			rowsCount: state => state.page.rowsCount,
			nodeData: state => state.nodeData,
			nod:state=>state.nod
			}),
		},
		components:{
			Page,
			AreaTree,
			
		},
		
		mounted:function(){
			// this.echarts();
			// this.tableList(this.search.pageNumber)
			// this.statistics();
		},
		watch:{
			switchValue:function(newVal, oldVal){
				if(newVal==="chart"){
					this.showChart=true;
					this.showList=false;
					// this.$nextTick(function(){let myChart = this.$echarts.init(document.getElementById('myChart'));
					// myChart.setOption(this.myChart);})
				
				}else{
					this.showChart=false;
					this.showList=true;
				}
			},
		}
	}

</script>
<style>
.ioRecord  .el-select{
	width:100px;
}
.switchGroup  .el-input__inner{
	 border:1px solid #67C23A;
		border-radius:4px;
}
</style>